<template>
  <v-data-table
    :headers="localHeaders"
    :items="items"
    :search="search"
    :pagination.sync="pagination"
    :rows-per-page-items="rowsPerPageItems"
    class="elevation-0"
    item-key="id"
  >
    <template v-slot:progress>
      <v-progress-linear
        color="success"
        height="3"
        indeterminate
      />
    </template>

    <template v-slot:items="props">
      <tr :class="{'grey lighten-2': isToday(props.item)}">
        <td
          v-for="{ value: field } in localHeaders"
          :key="field"
          class="no-wrap"
          :class="{'justify-center layout px-0': field === 'id', 'font-weight-bold': isToday(props.item)}"
        >
          <template v-if="field === 'name'">
            <router-link
              @click.prevent.stop
              :to="linkTo(props.item)"
            >
              {{ props.item[field] }}
            </router-link>
          </template>

          <template v-else-if="typeof props.item[field] === 'object'">
            <template v-if="Array.isArray(props.item[field])">
              <ul>
                <li v-for="(value, index) in props.item[field]" :key="index">
                  <template v-if="typeof value === 'object'">
                    {{ value.name || value.title }}
                  </template>
                  <template v-else>
                    {{ value }}
                  </template>
                </li>
              </ul>
            </template>
            <template v-else>
              <template v-if="field.includes('date')">
                {{ props.item[field].from.value }} - {{ props.item[field].to.value }}
              </template>
              <template v-else>
                {{ props.item[field].name || props.item[field].title || props.item[field].username }}
              </template>
            </template>
          </template>

          <template v-else>
            <template v-if="field === 'date_created'">
              {{ new Date(props.item[field]).toLocaleDateString().split('.').reverse().join('-') }}
            </template>
            <template v-else-if="field === 'status'">
              {{ props.item[field].replace(/\_/g, ' ') }}
            </template>
            <template v-else-if="field === 'id'">
              {{ props.item[field] }}
            </template>
            <template v-else>
              {{ props.item[field] }}
            </template>
          </template>
        </td>
      </tr>
    </template>

    <template
      v-slot:no-results
      align="center"
      class="error--text"
    >
      Your search for "{{ search }}" found no results.
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'dataTable',
  props: {
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    headers: {
      type: Array,
      default() {
        return [];
      },
    },
    search: {
      type: String,
      default() {
        return '';
      },
    },
  },
  data() {
    return {
      rowsPerPageItems: [
        4, 8, 16,
        { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 },
      ],
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: -1,
        sortBy: 'id',
        totalItems: 0,
      },
    };
  },
  watch: {
    items: {
      immediate: true,
      handler(items) {
        this.pagination.totalItems = items.length;
      },
    },
  },
  computed: {
    localHeaders() {
      return this.headers.filter(head => head.active);
    },
  },
  methods: {
    isToday(item) {
      const today = new Date().toISOString().substr(0, 10);
      return today === item.scheduled_date_rng.from.value.substr(0, 10);
    },
    linkTo(item) {
      return {
        name: this.allRoutes.trial.children.trialDetail.name,
        params: {
          id: item.id,
          from: this.$route.name,
        },
      };
    },
  },
};
</script>
